import { render, staticRenderFns } from "./Yach.vue?vue&type=template&id=f1b8caf4"
import script from "./Yach.vue?vue&type=script&lang=js"
export * from "./Yach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports